<template>
  <section>
    <div class="wrapper">
      <div class="cmdp_b">
        <div class="sub_list">
          <h2>{{ sendInfo.sendScnNm }} 발송 조회</h2>
          <div class="mgt20">
              <h3>
              진행 상태
                <span v-if="sendInfo.status==='00'" class="process03 process_icon mgl20">{{ sendInfo.statusNm }}</span>
                <span v-else-if="sendInfo.status==='01'" class="process01 process_icon mgl20">{{ sendInfo.statusNm }}</span>
                <span v-else-if="sendInfo.status==='02'" class="process02 process_icon mgl20">{{ sendInfo.statusNm }}</span>
                <span v-else-if="sendInfo.status==='04'" class="process03 process_icon mgl20">{{ sendInfo.statusNm }}</span>
                <span v-else-if="sendInfo.status==='05'" class="process04 process_icon mgl20">{{ sendInfo.statusNm }}</span>
                <span v-else-if="sendInfo.status==='98'" class="process07 process_icon mgl20">{{ sendInfo.statusNm }}</span>
                <span v-else-if="sendInfo.status==='99'" class="process08 process_icon mgl20">{{ sendInfo.statusNm }}</span>
              </h3>
          </div>
          <div class="mgt20">
            <h3>보내시는분 정보</h3>
            <dl class="box_input box_fl">
              <div>
              <dt>이름</dt>
              <dd>{{ sendInfo.sendNm }}</dd>
              </div>
              <div>
              <dt>부서</dt>
              <dd>{{ sendInfo.sendDept }}</dd>
              </div>
              <div>
              <dt>전화번호</dt>
              <dd>{{ sendTel }}</dd>
              </div>
              <div>
              <dt>이메일</dt>
              <dd>{{ !!sendInfo.sendMailAddr ? sendInfo.sendMailAddr : '-' }}</dd>
              </div>
            </dl>
          </div>
          <div class="mgt20" v-if="sendInfo.steadYn === 'Y'">
            <h3>대리 발송인 정보</h3>
            <dl class="box_input box_fl mgt10">
              <div>
              <dt>대리인 이름</dt>
              <dd>{{ sendInfo.steadNm }}</dd>
              </div>
              <div>
              <dt>부서</dt>
              <dd>{{ sendInfo.steadDept }}</dd>
              </div>
              <div>
              <dt>대리인 전화번호</dt>
              <dd>{{ steadTel }}</dd>
              </div>
              <div>
              <dt>대리인 이메일</dt>
              <dd>{{ !!sendInfo.steadMailAddr ? sendInfo.steadMailAddr : '-' }}</dd>
              </div>
            </dl>
          </div>
          <div class="mgt20">
            <h3>물품 정보</h3>
            <dl class="box_input box_fl" v-if="sendInfo.sendScn === '01'">
                <div>
                  <dt>용도</dt>
                  <dd>{{ sendInfo.ppsScnNm }}</dd>
                </div>
                <div>
                  <dt>운송사</dt>
                  <dd>{{ sendInfo.shpcScnNm }}</dd>
                </div>
                <div v-if="sendInfo.status === '99'">
                  <dt>운송장 번호</dt>
                  <dd>{{ !!sendInfo.blNo ? sendInfo.blNo : '-' }}</dd>
                </div>
                <div>
                  <dt>등기 종류</dt>
                  <dd>{{ sendInfo.deliveryScnNm }}</dd>
                </div>
                <div>
                  <dt>내용물</dt>
                  <dd>{{ sendInfo.contentsScn==='03' ? `${sendInfo.contentsScnNm} (${sendInfo.contentsScnDesc})` : sendInfo.contentsScnNm }}</dd>
                </div>
            </dl>
            <dl class="box_input" v-if="sendInfo.sendScn === '02'">
              <div class="box_flex box_fl">
                <div>
                  <dt>물품명</dt>
                  <dd>{{ !!sendInfo.itemNm ? sendInfo.itemNm : '-' }}</dd>
                </div>
                <div>
                    <dt>신고 금액</dt>
                  <dd>{{ regCost }}</dd>
                </div>
                <div>
                  <dt>수량</dt>
                  <dd>{{ sendInfo.qty }}</dd>
                </div>
                <div>
                  <dt>운송사</dt>
                  <dd>{{ sendInfo.shpcScnNm }}</dd>
                </div>
                <div v-if="sendInfo.status === '99'">
                  <dt>운송장 번호</dt>
                  <dd>{{ !!sendInfo.blNo ? sendInfo.blNo : '-' }}</dd>
                </div>
              </div>
            </dl>
            <dl class="box_input box_fl" v-if="sendInfo.sendScn === '03'">
              <div>
                <dt>운송사</dt>
                <dd>{{ sendInfo.shpcScnNm }}</dd>
              </div>
              <div>
                <dt>운송장 번호</dt>
                <dd>{{ !!sendInfo.blNo ? sendInfo.blNo : '-' }}</dd>
              </div>
              <div>
                <dt>수량</dt>
                <dd>{{ sendInfo.qty }}</dd>
              </div>
              <div>
                <dt>우든 포장</dt>
                <dd>{{ sendInfo.woodenYn }}</dd>
              </div>
            </dl>
          </div>
          <div class="mgt10 pd0" v-if="sendInfo.sendScn !== '03'">
        <h3 v-if="sendInfo.sendScn !== '03'">받는 분 정보</h3>
            <dl class="box_input" v-if="sendInfo.sendScn !== '03'">
              <dt>받는 분</dt>
              <dd>{{ sendInfo.receiveNm }}</dd>
              <div v-if="sendInfo.sendScn === '02'">
                <dt>받는 분 연락처</dt>
                <dd>{{ receiveTel }}</dd>
              </div>
              <dt>받는 분 주소</dt>
              <dd>{{ receiveAddrWithPostNo }}</dd>
            </dl>
          </div>
          <div class="box_btn">
            <div v-show="!isAfterSave && sendInfo.status === '00'" class="mid_btn dgray w100" @click="onClickCancel">취소하기</div>
            <div v-show="!isAfterSave && sendInfo.status === '00'" class="mid_btn dgray w100" @click="redirectToUpdate">수정</div>
            <div v-show="isAfterSave" class="mid_btn dgray w100" @click="redirectToSave">추가 예약하기</div>
            <div v-show="isAfterSave" class="mid_btn w100" @click="redirectToUpdate">수정</div>
            <div class="mid_btn w100" @click="redirectToList">목록</div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ApiConfig from "@/api/api.config";
import ApiUtil from "@/api/api.util";
import EtnersParseUtil from "@/common/etners.parse.util";
import EtnersCommonUtil from "@/common/etners.common.util";

export default {
  name: "ReserveDetail",
  mounted() {
    const vm = this
    vm.getSendDetail()
    vm.isAfterSave = (sessionStorage.getItem('LAST_ROUTE_NAME') === 'ReserveUpsert')
  },
  computed: {
    sendTel () {
      return EtnersParseUtil.convertTelNo(this.sendInfo.sendTel)
    },
    steadTel () {
      return EtnersParseUtil.convertTelNo(this.sendInfo.steadTel)
    },
    receiveTel () {
      return EtnersParseUtil.convertTelNo(this.sendInfo.receiveTel)
    },
    regCost () {
      return EtnersCommonUtil.numberWithCommas(this.sendInfo.regCost)
    },
    receiveAddrWithPostNo () {
      const vm = this

      const receivePost = vm.sendInfo.receivePost
      const receiveAddr = vm.sendInfo.receiveAddr
      const receiveAddrDtl = vm.sendInfo.receiveAddrDtl

      if(receivePost !== null && receiveAddr !== null){
        return `(${receivePost}) ${receiveAddr}  ${receiveAddrDtl}`
      }else{
        return ''
      }
    },
  },
  methods: {
    getSendDetail () {
      const vm = this

      const param = {
        loginUserToken: vm.loginUserToken,
        sendId: vm.$route.params.sendId,
      }

      const jsonUrl = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/reserveSend/sendReserveDetail.json`

      ApiUtil.post(jsonUrl, param).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
          return false
        }
        const resultStatus = response.data.resultStatus

        if (resultStatus.messageCode !== '2000') {
          kendo.alert(resultStatus.messageText)
          return false
        }

        const resultData = response.data.resultData

        vm.sendInfo = resultData
      })

    },

    onClickCancel () {
      const vm = this
      const param = {
        loginUserToken: vm.loginUserToken,
        sendId: vm.$route.params.sendId,
      }
      kendo.confirm('<p style="text-align: center;">예약하신 물품을 취소하시겠습니까?<br><span class="forg">*취소 시 수정 및 재발송이 어렵습니다.  </span></p>').done(() => {
        const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/reserveSend/sendReserveUpdateStatus.json`
        ApiUtil.post(url, param).then(response => {
          if (response.data === undefined || response.data.resultStatus === undefined) {
            kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
            return false
          }
          const resultStatus = response.data.resultStatus

          if (resultStatus.messageCode !== '2000') {
            kendo.alert(resultStatus.messageText)
            return false
          }
          kendo.alert('예약이 취소되었습니다.')
          vm.getSendDetail()
        })
      })
    },

    redirectToList () {
      this.$router.push({
        name: 'ReserveList',
      })
    },

    redirectToUpdate () {
      this.$router.push({
        name: 'ReserveUpdate',
        params: {
          sendScn: this.sendInfo.sendScn,
          sendId: this.sendInfo.sendId,
        }
      })
    },

    redirectToSave () {
      this.$router.push({
        name: 'ReserveUpsert',
        params: {
          sendScn: this.sendInfo.sendScn
        }
      })
    },
  },
  data () {
    return {
      loginUserToken: sessionStorage.getItem('ssoUserToken'),
      isAfterSave: false,
      sendInfo: {},
    }
  }
}
</script>

<style scoped>

</style>